import g from '#core/global';
import load from '#core/load';


const select_$ = '.select__select';
const container_$ = '.select__container';
const value_display_$ = '.select__value';

let has_select = false;
let $selects = null;


const module = {
	
	/**
	 * Init module
	 */
	init($scope = null) {
		if (load.ran('select')) return false;
		
		load.content(() => {
			has_select = this.update($scope);
			if (!has_select) return false;
		});
		load.all(() => {
			has_select = this.update($scope);
			if (!has_select) return false;
		});
	},
	
	
	/**
	 * Update
	 * @param {element} $scope
	 * @return {boolean}
	 */
	update($scope = null) {
		return assign_elements($scope);
	},
	
	
	/**
	 * Reset
	 * @param {element} $select
	 * @param {int} index
	 * @param {boolean} fire
	 */
	reset($select, index = 0, fire = false) {
		reset($select, index, fire);
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @param {element} $scope
 * @return {boolean}
 */
function assign_elements($scope = null) {
	if (has_select) return true;
	
	$scope = $scope || document;
	$selects = $scope.querySelectorAll(select_$);
	if (!$selects.length) return false;
	
	$selects.forEach($select => {
		$select.addEventListener(g.change_e, e => {
			update($select);
		});
		update($select);
	});
	
	return true;
}


/**
 * Update select
 * @param {element} $select
 */
function update($select) {
	if (!$select.options.length) return false;
	
	const value = $select.value;
	const text = $select.options[$select.selectedIndex].text;
	if (!value && !text) return false;
	
	const $container = $select.closest(container_$);
	const $value_display = $container.querySelector(value_display_$);
	
	$value_display.innerHTML = text;
}


/**
 * Reset select
 * @param {element} $select
 * @param {int} index
 * @param {boolean} fire
 */
function reset($select, index = 0, fire = false) {
	if (!$select.options.length) return false;
	
	const value = $select.options[index].value;
	const text = $select.options[index].text;
	if (!value && !text) return false;
	
	$select.selectedIndex = index;
	$select.value = value;
	update($select);
	
	if (!fire) return false;
	
	$select.dispatchEvent(new Event(g.change_e));
}
